import { h, setChildren } from "../core/dom.js";
import { api } from "../api.js";
import { navigate } from "../core/router.js";
import { icon } from "../lib/icons.js";
import { backLink } from "../components/common.js";
import { MuscleMap } from "../components/MuscleMap.js";
import { spinner, errorState, toast, confirmDialog } from "../components/ui.js";
import { reportButton } from "../components/report.js";

export default function PublicProgram({ id }) {
  const root = h("div", { class: "screen" });
  let data = null;
  load();

  async function load() {
    setChildren(root, backLink("Discover", "/discover"), spinner());
    try {
      data = await api.sharedProgram(id);
      render();
    } catch (e) {
      setChildren(root, backLink("Discover", "/discover"), errorState(e.message, () => navigate("/discover")));
    }
  }

  function render() {
    const author = data.owner.display_name || data.owner.username;
    const weeks = Math.ceil(data.day_count / 7) || 0;
    setChildren(root,
      backLink("Discover", "/discover"),
      h("div", { class: "card" },
        h("h1", { class: "detail-title" }, data.name),
        h("div", { class: "dim", style: { marginTop: "2px" } }, "by ", author, data.is_own ? " (you)" : ""),
        data.source_author ? h("div", { class: "dim hstack", style: { marginTop: "4px", gap: "4px", fontSize: ".8rem" } }, icon("copy", { size: 13 }), data.source_name ? `Adapted from ${data.source_name} by ${data.source_author}` : `Adapted from ${data.source_author}`) : null,
        data.description ? h("p", { style: { marginTop: "10px" } }, data.description) : null,
        h("div", { class: "hstack", style: { marginTop: "10px", gap: "14px", flexWrap: "wrap", fontSize: "0.85rem" } },
          h("span", { class: "dim" }, `${data.day_count} day${data.day_count === 1 ? "" : "s"}${weeks > 1 ? ` · ${weeks} weeks` : ""}`),
          h("span", { class: "dim" }, `${data.workout_day_count} workout${data.workout_day_count === 1 ? "" : "s"}`),
          h("span", { class: "dim hstack", style: { gap: "4px" } }, icon("user", { size: 15 }), `${data.use_count} enrolled`)
        )
      ),

      data.is_own
        ? h("div", { class: "card mt center dim", style: { fontSize: ".85rem" } }, "This is your published program — others can enroll in it from here.")
        : h("button", { class: "btn btn-primary btn-block btn-lg mt", onClick: enroll },
            icon(data.already_enrolled ? "check" : "download", { size: 20 }),
            data.already_enrolled ? "Enroll again" : "Enroll — copy to my programs"),

      h("div", { class: "section-title" }, "Schedule"),
      h("div", null, ...data.days.map(dayRow)),

      !data.is_own ? h("div", { class: "center", style: { marginTop: "20px" } },
        reportButton({ targetType: "program", targetId: Number(id), name: `${data.name} by ${author}` })) : null
    );
  }

  function dayRow(d, i) {
    if (i % 7 === 0) {
      // Week heading before the first day of each week.
    }
    const weekHead = i % 7 === 0 ? h("div", { class: "section-title", style: { margin: "10px 0 4px" } }, `Week ${Math.floor(i / 7) + 1}`) : null;

    let body;
    if (d.is_rest || !d.workout) {
      body = h("div", { class: "card hstack", style: { marginBottom: "8px", alignItems: "center", gap: "10px" } },
        h("div", { class: "set-num", style: { flex: "0 0 auto" } }, `D${i + 1}`),
        h("div", { class: "grow" },
          h("div", { style: { fontWeight: 600, color: "var(--muted)" } }, d.label || "Rest day"),
          h("div", { class: "dim", style: { fontSize: ".78rem" } }, "Recovery")
        )
      );
    } else {
      const mini = MuscleMap({ primary: d.workout.primary_muscle_ids || [] });
      mini.classList.add("mini");
      mini.style.maxWidth = "52px";
      body = h("div", { class: "card hstack", style: { marginBottom: "8px", alignItems: "center", gap: "10px" } },
        h("div", { class: "set-num", style: { flex: "0 0 auto" } }, `D${i + 1}`),
        mini,
        h("div", { class: "grow" },
          h("div", { style: { fontWeight: 600 } }, d.label || d.workout.name),
          h("div", { class: "dim", style: { fontSize: ".78rem" } }, `${d.workout.exercise_count} exercise${d.workout.exercise_count === 1 ? "" : "s"}`)
        )
      );
    }
    return weekHead ? h("div", null, weekHead, body) : body;
  }

  async function enroll() {
    if (data.already_enrolled) {
      const ok = await confirmDialog({ title: "Enroll again?", message: "You've already enrolled in this program. Add another copy?", confirmText: "Add copy" });
      if (!ok) return;
    }
    try {
      const res = await api.enrollProgram(id);
      toast(res.activated ? "Enrolled — now your active program" : "Added to your programs", "success");
      navigate("/programs");
    } catch (e) {
      toast(e.message, "error");
    }
  }

  return root;
}
